<template>
  <div class="cms-view">
    <transition name="fade" mode="out-in">
      <MainHero
        v-if="
          [
            orderProcess.STEPS.NO_ORDER_ONGOING,
            orderProcess.STEPS.ORDER_COMPLETED,
          ].includes(currentOrderProcessStep)
        "
      ></MainHero>
      <CheckoutHero
        v-else-if="
          ![viewports.MOBILE.name, viewports.TABLET.name].includes(
            currentViewport
          )
        "
      ></CheckoutHero>
    </transition>
    <transition name="fade">
      <div class="cms-view__content py-6">
        <div class="container py-6">
          <template
            v-if="
              $route.path === '/produktion/tipps-und-tricks-im-3d-druck' &&
                pageContent
            "
          >
            <div class="product-box-container">
                <CMSViewComponent
                  v-for="element in pageContent"
                  :key="'cms_content_element_' + element.id"
                  :element="element"
                />
            </div>
          </template>
          <template v-else>
            <div class="columns call-to-action">
              <div class="column is-full">
                <div
                  class="title has-text-primary is-size-3 is-size-2-desktop hyphenate"
                >
                  {{ $t("cms.main.titleTop") }}
                </div>
                <div
                  class="title has-text-primary is-size-4 is-size-3-desktop hyphenate"
                >
                  {{ $t("cms.main.titleBottom") }}
                </div>
              </div>
            </div>
            <div class="columns has-background-white call-to-action">
              <div class="column">
                <p>
                  {{ $t("cms.main.firstParagraph") }}
                  <br />
                  <br />
                </p>
                <p>
                  {{ $t("cms.main.secondParagraph") }}
                  <br />
                  <br />
                </p>
                <p>
                  {{ $t("cms.main.thirdParagraph") }}
                  <br />
                  <br />
                </p>
                <p>
                  {{ $t("cms.main.fourthParagraph") }}
                </p>
              </div>
              <div class="column is-8-desktop">
                <figure class="image call-to-action__Img">
                  <!-- TODO: There might be a better solution for 'translating' the image
                  (expressions inside :src will be lost to the bundler, though -->
                  <template v-if="$i18n.locale === 'de-DE'">
                    <img
                      src="@/assets/img/Maagtechnic_Grafik_3D_de-DE.png"
                      alt="Placeholder image"
                    />
                  </template>
                  <!-- Right now the only other option besides 'de-DE' is 'fr-FR' -->
                  <template v-else>
                    <img
                      src="@/assets/img/Maagtechnic_Grafik_3D_fr-FR.png"
                      alt="Placeholder image"
                    />
                  </template>
                </figure>
              </div>
            </div>
          </template>
        </div>

        <div class="container py-6">
          <div class="columns call-to-action">
            <div class="column">
              <div class="title is-size-5 is-size-4-desktop hyphenate">
                {{ $t("cms.chooseFile.title") }}
              </div>
              <p v-html="$t('cms.chooseFile.firstParagraph')"></p>
              <p>
                {{ $t("cms.chooseFile.secondParagraph") }}
                <br />
                <br />
              </p>
              <p>
                {{ $t("cms.chooseFile.thirdParagraph") }}
                <br />
                <br />
              </p>
            </div>
          </div>
        </div>
        <div class="container py-6">
          <div class="columns call-to-action">
            <div class="column">
              <div class="title is-size-5 is-size-4-desktop hyphenate">
                {{ $t("cms.chooseMaterial.title") }}
              </div>
              <p v-html="$t('cms.chooseMaterial.firstParagraph')"></p>
              <p>
                {{ $t("cms.chooseMaterial.secondParagraph") }}
                <br />
                <br />
              </p>
            </div>
          </div>
        </div>

        <div class="container py-6">
          <div class="columns call-to-action">
            <div class="column">
              <div class="title is-size-5 is-size-4-desktop hyphenate">
                {{ $t("cms.printModes.title") }}
              </div>
            </div>
          </div>

          <div class="columns call-to-action is-flex-wrap-wrap is-justify-content-center">
            <div class="column content is-one-third-widescreen is-half">
              <div
                class=" title is-size-5 is-size-4-desktop hyphenate has-text-primary"
              >
                {{ $t("cms.printModes.pa2200.title") }}
              </div>
              <p>
                {{ $t("cms.printModes.pa2200.description") }}
              </p>
              <p
                class="title is-5"
                v-html="$t('cms.printModes.pa2200.advantagesTitle')"
              ></p>

              <ul v-html="$t('cms.printModes.pa2200.advantages')"></ul>

              <table class="table is-striped is-bordered">
                <tbody>
                  <tr v-html="$t('cms.printModes.pa2200.tableRow1')"></tr>
                  <tr v-html="$t('cms.printModes.pa2200.tableRow2')"></tr>
                  <tr v-html="$t('cms.printModes.pa2200.tableRow3')"></tr>
                  <tr v-html="$t('cms.printModes.pa2200.tableRow4')"></tr>
                </tbody>
              </table>
              <p v-html="$t('cms.printModes.pa2200.dataSheet')"></p>
            </div>

            <div class="column content is-one-third-widescreen is-half">
              <div
                class="title is-size-5 is-size-4-desktop hyphenate has-text-primary"
              >
                {{ $t("cms.printModes.alumide.title") }}
              </div>
              <p>
                {{ $t("cms.printModes.alumide.description") }}
              </p>
              <p
                class="title is-5"
                v-html="$t('cms.printModes.alumide.advantagesTitle')"
              ></p>

              <ul v-html="$t('cms.printModes.alumide.advantages')"></ul>
              <table class="table is-striped is-bordered">
                <tbody>
                  <tr v-html="$t('cms.printModes.alumide.tableRow1')"></tr>
                  <tr v-html="$t('cms.printModes.alumide.tableRow2')"></tr>
                  <tr v-html="$t('cms.printModes.alumide.tableRow3')"></tr>
                  <tr v-html="$t('cms.printModes.alumide.tableRow4')"></tr>
                </tbody>
              </table>
              <p v-html="$t('cms.printModes.alumide.dataSheet')"></p>
            </div>

            <div class="column content is-one-third-widescreen is-half">
              <div
                class="title is-size-5 is-size-4-desktop hyphenate has-text-primary"
              >
                {{ $t("cms.printModes.pa3200gf.title") }}
              </div>
              <p>
                {{ $t("cms.printModes.pa3200gf.description") }}
              </p>
              <p
                class="title is-5"
                v-html="$t('cms.printModes.pa3200gf.advantagesTitle')"
              ></p>
              <ul v-html="$t('cms.printModes.pa3200gf.advantages')"></ul>

              <table class="table is-striped is-bordered">
                <tbody>
                  <tr></tr>
                  <tr v-html="$t('cms.printModes.pa3200gf.tableRow1')"></tr>
                  <tr v-html="$t('cms.printModes.pa3200gf.tableRow2')"></tr>
                  <tr v-html="$t('cms.printModes.pa3200gf.tableRow3')"></tr>
                  <tr v-html="$t('cms.printModes.pa3200gf.tableRow4')"></tr>
                </tbody>
              </table>

              <p v-html="$t('cms.printModes.pa3200gf.dataSheet')"></p>
            </div>

            <div class="column content is-one-third-widescreen is-half">
              <div
                class="title is-size-5 is-size-4-desktop hyphenate has-text-primary"
              >
                {{ $t("cms.printModes.tpu.title") }}
              </div>
              <p>
                {{ $t("cms.printModes.tpu.description") }}
              </p>
              <p
                class="title is-5"
                v-html="$t('cms.printModes.tpu.advantagesTitle')"
              ></p>
              <ul v-html="$t('cms.printModes.tpu.advantages')"></ul>

              <table class="table is-striped is-bordered">
                <tbody>
                  <tr></tr>
                  <tr v-html="$t('cms.printModes.tpu.tableRow1')"></tr>
                  <tr v-html="$t('cms.printModes.tpu.tableRow2')"></tr>
                  <tr v-html="$t('cms.printModes.tpu.tableRow3')"></tr>
                  <tr v-html="$t('cms.printModes.tpu.tableRow4')"></tr>
                </tbody>
              </table>

              <p v-html="$t('cms.printModes.tpu.dataSheet')"></p>
            </div>
            <div class="column content is-one-third-widescreen is-half">
              <div
                class="title is-size-5 is-size-4-desktop hyphenate has-text-primary"
              >
                {{ $t("cms.printModes.mursintpa12blue.title") }}
              </div>
              <p v-html="$t('cms.printModes.mursintpa12blue.description')">

              </p>
              <!--
              <p
                class="title is-5"
                v-html="$t('cms.printModes.mursintpa12blue.advantagesTitle')"
              ></p>
               Not provided in the current state of the ticket. But should... i guess.
                <ul v-html="$t('cms.printModes.mursintpa12blue.advantages')"></ul>

              <table class="table is-striped is-bordered">
                <tbody>
                  <tr></tr>
                  <tr v-html="$t('cms.printModes.mursintpa12blue.tableRow1')"></tr>
                  <tr v-html="$t('cms.printModes.mursintpa12blue.tableRow2')"></tr>
                  <tr v-html="$t('cms.printModes.mursintpa12blue.tableRow3')"></tr>
                  <tr v-html="$t('cms.printModes.mursintpa12blue.tableRow4')"></tr>
                </tbody>
              </table>
              -->
              <p v-html="$t('cms.printModes.mursintpa12blue.dataSheet')"></p>
            </div>
          </div>
        </div>


        <div class="container py-6">
          <div class="columns call-to-action">
            <div class="column">
              <div class="title is-size-5 is-size-4-desktop hyphenate">
                {{ $t("cms.placeOrder.title") }}
              </div>
              <p>
                {{ $t("cms.placeOrder.firstParagraph") }}
                <br />
                <br />
              </p>
              <p>
                {{ $t("cms.placeOrder.secondParagraph") }}
              </p>
            </div>
          </div>
        </div>

        <div class="container py-6">
          <div class="columns call-to-action">
            <div class="column">
              <div class="title is-size-5 is-size-4-desktop hyphenate">
                {{ $t("cms.finishedOrder.title") }}
              </div>
              <p v-html="$t('cms.finishedOrder.contact')"></p>
            </div>
          </div>
        </div>

        <div class="container py-6" style="width: 100%">
          <div class="youtube-container">
              <div class="video-container">
                <iframe width="100%" height="100%" :src="$t('cms.youtube.first.src')" :title="$t('cms.youtube.first.title')" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>
              <div class="video-container">
                <iframe width="100%" height="100%" :src="$t('cms.youtube.second.src')" :title="$t('cms.youtube.second.title')" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>
          </div>
        </div>

        <div class="section has-offset-background" style="width: 100%">
          <div class="container py-6">
            <div class="columns call-to-action">
              <div class="column">
                <div class="title is-size-5 is-size-4-desktop hyphenate">
                  {{ $t("cms.support.title") }}
                </div>
              </div>
            </div>
            <div class="columns call-to-action">
              <div class="column is-half content">
                <div class="box py-6">
                  <div
                    class="title is-size-5 is-size-4-desktop hyphenate has-text-primary"
                  >
                    {{ $t("cms.support.technical.title") }}
                  </div>
                  {{ $t("cms.support.technical.contact.name") }}
                  <br />
                  {{ $t("cms.support.technical.contact.division") }}
                  <br />
                  <br />
                  <p v-html="$t('cms.support.technical.contact.mail')"></p>
                  <p v-html="$t('cms.support.technical.contact.phone')"></p>
                </div>
              </div>
              <div class="column is-half content">
                <div class="box py-6">
                  <div
                    class="title is-size-5 is-size-4-desktop hyphenate has-text-primary"
                  >
                    {{ $t("cms.support.sales.title") }}
                  </div>
                  {{ $t("cms.support.sales.contact.name") }}
                  <br />
                  {{ $t("cms.support.sales.contact.division") }}
                  <br />
                  <br />
                  <p v-html="$t('cms.support.sales.contact.mail')"></p>
                  <p v-html="$t('cms.support.sales.contact.phone')"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <ContactForm v-if="$route.path === '/kontakt'" />
  </div>
</template>

<script>
import MainHero from "./layout/MainHero";
import Steps from "./layout/Steps";
import CMSViewComponent from "./cms-content-types/CMSViewComponent";
import CheckoutHero from "./checkout/CheckoutHero";
import { componentMapping } from "../store/constants/component-mapping";
import { orderProcess } from "../store/constants/order-process";
import { viewports } from "../store/constants/viewports";
import { mapGetters } from "vuex";
import LazyLoadedImage from "./shared/LazyLoadedImage";
import ContactForm from "./Forms/ContactForm";

export default {
  name: "CMSView",
  components: {
    ContactForm,
    CheckoutHero,
    CMSViewComponent,
    Steps,
    MainHero,
    LazyLoadedImage,
  },
  data() {
    return {
      componentMapping,
      orderProcess,
      viewports,
    };
  },
  computed: {
    ...mapGetters(["currentOrderProcessStep", "currentViewport"]),
    cmsPage() {
      return this.$store.getters.cmsPage;
    },
    pageContent() {
      return this.cmsPage.content ? this.cmsPage.content.colPos0 : null;
    },
  },
  methods: {
    fetchCMSData() {
      this.$store
        .dispatch("fetchCMSPage", { urlSlug: this.$route.path })
        .catch(() => {
          if (["/fr", ""].includes(this.$route.path)) return;
          this.$router.push("/not-available");
        });
    },
  },
  watch: {
    $route() {
      this.fetchCMSData();
    },
  },
  created() {
    this.fetchCMSData();
  },
};
</script>
<style lang="scss">
.section {
  &.has-offset-background {
    position: relative;
    margin-bottom: 6rem;
    &:before {
      content: "";
      width: 100%;
      height: 250px;

      position: absolute;
      left: 0;
      right: 0;
      top: 45%;
      background: #e9f5fb;
    }
  }
}

.youtube-container {
  display:grid;
  grid-template-columns: 1fr;
  gap: 0.5em;
  padding: 0 10%;

  @media screen and (min-width: 1024px) {
    grid-template-columns: 1fr 1fr;
  }
}

.video-container {
  width: 100%;
  aspect-ratio: 16 / 9;
}
.product-box-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0;
  gap: 0;

  --productBoxWidth: 100%;

  @media screen and (min-width: 576px) {
    $flexBoxCount: 2;
    $flexGap: 1rem;
    --productBoxWidth: calc(#{math.div(1,$flexBoxCount) * 100%} - #{$flexGap});
    gap: $flexGap;
    margin: 0 $flexGap 0 $flexGap;

  }
  @media screen and (min-width: $tablet) {
    $flexBoxCount: 2;
    $flexGap: 1.5rem;
    --productBoxWidth: calc(#{math.div(1,$flexBoxCount) * 100%} - #{$flexGap});
    gap: $flexGap;
    margin: 0 $flexGap 0 $flexGap;
  }

  @media screen and (min-width: $desktop) {
    $flexBoxCount: 3;
    $flexGap: 2.5rem;
    --productBoxWidth: calc(#{math.div(1,$flexBoxCount) * 100%} - #{$flexGap});
    gap: $flexGap;
    margin: 0 $flexGap 0 $flexGap;
  }

  @media screen and (min-width: $fullhd) {
    margin: 0 6rem 0 6rem;
  }
}
</style>
